import { z } from "zod"

import { BankDetailsSchema } from "./BankDetailsSchema"

import { PaymentAccountType, PaymentMethod } from "@/graphql/codegen/graphql"

export const PaymentMethodSchema = BankDetailsSchema.extend({
  companyId: z.string().min(1, "Company ID is required"),
  locationId: z.string().min(1, "Billing location is required"),
  accountType: z
    .nativeEnum(PaymentAccountType, {
      errorMap: () => ({ message: "Account type is required" }),
    })
    .nullable()
    .refine((val) => val !== null, { message: "Account type is required" }),
  method: z
    .nativeEnum(PaymentMethod, {
      errorMap: () => ({ message: "Payment method is required" }),
    })
    .nullable()
    .refine((val) => val !== null, { message: "Payment method is required" }),
  bankId: z.string().optional(),
  bankLocationId: z.string().optional(),
})

export type PaymentMethodFormValues = z.infer<typeof PaymentMethodSchema>
